<template>
    <div>
        <Header/>
        <!-- Carousel -->
        <div class="container">
            <h3 class="text-center text-bold mb-5 mt-5">รายการสั่งซื้อ</h3>
            <div class="row">
                <div class="col-lg-9 col-sm-12">
                    <div class="mb-2">
                        <div class="d-flex">
                            <div class="col-3">รายการ</div>
                            <div class="col-2">ราคาต่อชิ้น</div>
                            <div class="col-2">จำนวนชิ้น</div>
                            <div class="col-2">ราคา</div>
                            <div class="col-2">จำนวน</div>
                            <div class="col-1">ลบ</div>
                        </div>
                    </div>
                    <div class="card" v-for="(cart,index) in $root.carts" :key="cart.index">
                        <div class="card-body d-flex">
                            <div class="col-3 d-flex">
                                <div class="col-3">
                                    <img :src="getImg(cart.product_image)" class="img-fluid">
                                </div>
                                <div class="col-9">
                                    <span class="text-10">{{cart.product_name}}</span>
                                </div>
                            </div>
                            <div class="col-2">
                                <span class="text-12"><b class="text-primary">฿</b> {{ (cart.product_unit == 'ลัง') ? cart.crate_unit : cart.pack_unit }}</span>
                            </div>
                            <div class="col-2">
                                <span class="text-12">{{ (cart.product_unit == 'ลัง') ? cart.crate : cart.pack }}</span>
                            </div>
                            <div class="col-2">
                                <span class="text-12"><b class="text-primary">฿</b> {{ (cart.product_unit == 'ลัง') ? ((cart.crate_unit * cart.crate) * cart.amount) : ((cart.pack_unit * cart.pack) * cart.amount) | numberFormat }}</span>
                            </div>
                            <div class="col-2">
                                <span class="text-12">{{cart.amount}} {{cart.product_unit}}</span>
                            </div>
                            <div class="col-1">
                                <span @click="$root.removeCart(index)" class="text-danger text-12" title="ลบรายการนี้"><i class="fas fa-trash"></i> ลบ</span>
                            </div>
                        </div>
                    </div>
                    <router-link to="/" class="btn btn-sm btn-block btn-primary">สั่งสินค้าเพิ่ม</router-link>
                    <div v-if="$root.carts ==''" class="mt-5 mb-5">
                        <h5 class="text-gray text-center">ไม่มีรายการสั่งซื้อ</h5>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            <h6>สรุปรายการสั่งซื้อ</h6>
                            <div class="d-flex justify-content-between text-12">
                                <div>จำนวน</div>
                                <div>{{$root.carts.length}}</div>
                            </div>
                            <div class="d-flex justify-content-between text-12">
                                <div>ยอดรวมทั้งสิน</div>
                                <div>฿ {{$root.totalPrice | numberFormat}}</div>
                            </div>
                            <hr>
                            <form @submit.prevent="checkOut()">
                                <div class="form-group">
                                    <label class="text-12">ชื่อ: <span class="text-gray">(ชื่อร้าน)</span></label>
                                    <input type="text" v-model="form.name" v-validate="'required'" name="name" class="form-control form-control-sm" :class="{'input': true, 'is-invalid': errors.has('name') }" placeholder="ชื่อ (ชื่อร้าน)">
                                    <i v-show="errors.has('name')" class="fas fa-warning"></i>
                                    <span v-show="errors.has('name')" class="text-danger text-10">{{ errors.first('name') }}</span>
                                </div>
                                <div class="form-group">
                                    <label class="text-12">เบอร์โทรศัพท์:</label>
                                    <input type="text" v-model="form.phone" v-validate="'required|numeric|min:10|max:15'" name="phone" class="form-control form-control-sm" :class="{'input': true, 'is-invalid': errors.has('phone')}" placeholder="เบอร์โทรศัพท์">
                                    <i v-show="errors.has('phone')" class="fas fa-warning"></i>
                                    <span v-show="errors.has('phone')" class="text-danger text-10">{{ errors.first('phone') }}</span>
                                </div>
                                <div class="form-group">
                                    <label class="text-12">ที่อยู่:</label>
                                    <textarea v-model="form.address" v-validate="'required'" name="address" class="form-control form-control-sm" :class="{'input': true, 'is-invalid': errors.has('address')}" cols="30" rows="2" placeholder="ที่อยู่"></textarea>
                                    <i v-show="errors.has('address')"></i>
                                    <span v-show="errors.has('address')" class="text-danger text-10">{{errors.first('address')}}</span>
                                </div>
                                <div class="form-group">
                                    <label class="text-12">ข้อความ:</label>
                                    <textarea v-model="form.message" v-validate="'required'" name="message" class="form-control form-control-sm" :class="{'input': true, 'is-invalid': errors.has('message')}" cols="30" rows="4" placeholder="ข้อความ"></textarea>
                                    <i v-show="errors.has('message')"></i>
                                    <span v-show="errors.has('message')" class="text-danger text-10">{{errors.first('message')}}</span>
                                </div>
                                <div v-if="!$root.checkLoginCustomer" class="form-group">
                                    <button type="button" class="btn btn-sm btn-block bg-orange text-light" @click="alerLogin()">ยืนยันการสั่งซื้อ</button>
                                </div>
                                <div v-else class="form-group">
                                    <button type="submit" class="btn btn-sm btn-block bg-orange text-light">ยืนยันการสั่งซื้อ</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            
        </div><!-- Container -->
        <br><br><br><br>
        <Footer/>
    </div> <!-- end root -->
</template>
<style scoped>

</style>
<script>
import Header from '../components/Header'
import Footer from '../components/Footer'
    export default {
        components : {
            Header,Footer,
        },
        data(){
            return {
                modal_login: false,
                form: new Form({
                    cus_id:this.$root.keyid_cus,
                    name:'',
                    phone:'',
                    address:'',
                    message:'',
                    list_product:this.$root.carts.length,
                    total_price:this.$root.totalPrice,
                    products:this.$root.carts,
                })
            }
        },
        methods: {
            alerLogin(){
                swal.fire({
                type: 'error',
                title: 'Oops...',
                text: 'กรุณาล็อคอินก่อนยืนยันการสั่งซื้อ!',
                })
            },
            getImgModal(){
                return '../../dist/typeProduct/20190513_1.jpg'
            },
            modalUp(){
                this.modal_login = true
            },
            getImg(img){
                return 'http://pgm01.toonjob.com/2019/BannKlong/image/products/'+img
            },
            checkOut(){
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.form.post('http://pgm01.toonjob.com/2019/BannKlong/project/checkOutOrder')
                        .then((res) => {
                            toast.fire({
                                type:'success',
                                title:res.data.message
                            })
                            this.form.reset()
                            this.removeCart()
                            console.log(res.data)
                        })
                    }
                })
            },
            removeCart(){
                localStorage.removeItem('carts')
                window.location.href = ''
            }
        },
        created() {
            this.$Progress.start()    
            
            this.$Progress.finish()
        },
    }
</script>



// WEBPACK FOOTER //
// src/frontEnd/CheckOutProduct.vue